module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2fm"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Acknowledgments")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This book attempts to capture the outdoor philosophy and techniques of the National Outdoor Leadership School and therefore credit should go to the many staff members and instructors (beginning with founder Paul Petzoldt) who have made the school what it is today")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many people helped to produce this book. My thanks for the invaluable assistance, ideas, and encouragement from the NOLS review committee: Jim Ferguson, John Gookin, Lannie Hamilton, Phil Powers, Tom Reed, and Liz Alva Rosa.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Molly Doran, Tod Shimelpfenig, Kevin McGowan, Drew Leemon, and Rich Brame offered excellent suggestions in their areas of expertise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Four readers outside NOLS helped me very much with the manuscript: Joan McCarter, Ann Harvey, Connie Harvey, and John Katzenberger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks to my agent, Michael Congdon, for his help in all aspects of the production of this book. Thanks to Molly Hampton, NOLS director of personnel, for her help in launching this project in the early stages.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am grateful to the executive director of NOLS, John Gans, and the NOLS board of trustees for their support of the project.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Simon & Schuster, I would like to thank Sarah Baker, Betsy Radin-Herman, Bette Alexander, and Matt Walker for their skillful editing and management of the production process.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Thank you John Roskelley, Pamela Eaton, Jeff Foott, Molly Doran, Buck Tilton, and Sam Talucci for taking the time to be interviewed.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("To Rick Ruhman, my appreciation for your hard work on the illustrations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, I am very grateful to Molly Absolon for her tremendous skills and constant support in all stages of the production of this book—thanks, Molly!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fcc4654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 72
// module chunks = 0